import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    width: 100%;
    justify-content: flex-end;
    align-items: center;
    flex-direction: column;
    padding: 15px;
`;

export const BarContainer = styled.div`
    display: flex;
    position: relative;
    width: 100%;
    height: 40px;
    flex-direction: row;
    justify-content: flex-start;
    background-color: #F6F6F6;
    border-radius: 10px;
    @media (min-width: 720px) {
        height: 60px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        height: 40px;
    }
`;

export const ContentContainer = styled.div`
    height: 40px;
    background: #F3CC9F;
    border-radius: 10px;
    width: ${props => props.width ? props.width : '0%'};
    @media (min-width: 720px) {
        height: 60px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        height: 40px;
    }
`;

export const NameText = styled.span`
    display: flex;
    font-size: 14px;
    font-weight: 500;
    color: #333;
    width: 100%;
    text-align: left;
    @media (min-width: 720px) {
        font-size: 20px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        font-size: 14px;
    }
`;

export const TextSoma = styled.span`
    position: absolute;
    display: flex;
    font-size: 12px;
    font-weight: 700;
    color: #464646;
    right: 10px;
    top: 15px;
    @media (min-width: 720px) {
        top: 18px;
        font-size: 16px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        font-size: 12px;
        top: 15px;
    }
`;